import Link from "@/components/link";
import { ArrowLeft } from "lucide-react";
import { Footer } from "@/components/footer";
import { useDocumentTitle } from "@/lib/use-document-title";

export default function Diffusion() {
  useDocumentTitle("Diffusion Math from Scratch");

  return (
    <main className="min-h-screen bg-[#f8f7f4] flex flex-col font-cm-serif">
      <div className="container mx-auto py-8 px-4 md:px-6 flex-grow">
        <Link
          href="/"
          className="inline-flex items-center text-gray-700 hover:text-gray-900 mb-8"
        >
          <ArrowLeft size={16} className="mr-2" />
          Back to home
        </Link>

        <div className="max-w-4xl mx-auto">
          {/* Top bar - 6px */}
          <div className="w-4/5 h-[6px] bg-black mx-auto mb-4"></div>

          <h1 className="text-4xl font-bold mb-4 text-center">
            Diffusion Math from Scratch
          </h1>

          {/* Bottom bar - 2px */}
          <div className="w-4/5 h-[2px] bg-black mx-auto mb-8"></div>

          {/* Author information */}
          <div className="text-center mb-6">
            <p className="text-md font-bold">Isaac Bautista Silva</p>
            <p className="text-md">me@isaacbau.com</p>
          </div>

          {/* Abstract section */}
          <div className="mt-8 mb-8">
            <h2 className="text-2xl font-bold text-center mb-4">Abstract</h2>
            <p className="text-lg leading-relaxed text-justify max-w-4xl mx-auto px-8">
              Diffusion math is infamous for being complicated but in a single
              video I try to convince you that it's not.
            </p>
          </div>

          <div className="w-full max-w-3xl mx-auto px-4 md:px-12 mb-12">
            <div className="relative pb-[56.25%] h-0 overflow-hidden rounded-md shadow-md">
              <iframe
                className="absolute top-0 left-0 w-full h-full"
                src="https://www.youtube.com/embed/hRi3ouF1vqY"
                title="Diffusion Math from Scratch"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="mt-4 text-center">
              <Link
                href="https://colab.research.google.com/drive/1rVK24qP9qBkZ_45V1ob6yb8PubItA_WH?usp=sharing"
                target="_blank"
                className="inline-flex items-center text-blue-600 hover:text-blue-800 text-sm mr-4"
              >
                <span>Local Stable Diffusion Code</span>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </main>
  );
}
